import { useApolloClient } from "@apollo/client/react";
import styled from "@emotion/styled";
import Button from "@mostrans/web-components/components/base/Button";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box } from "@mui/material";
import React, { useState } from "react";
import { updateCandidateEmailPhoneNumber } from "../../graphql/mutations";
import { toastError, toastSuccess, toastWarning } from "../../shared/helpers";

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;
  width: 100%;
  justify-content: flex-start;
  font-size: 18px;
  font-weight: 500;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  label {
    color: #262626;
    text-transform: capitalize;
  }
`;

const ChangeVerification = (props) => {
  const { setChangeVerification, data, setData } = props;
  const [values, setValues] = useState({
    email: null,
    phone_number: null,
    current_email: data?.email,
    current_number: data?.phone_number,
  });
  const [isError, setIsError] = useState(false);
  const client = useApolloClient();

  const regex_phone = /^((\+62 8\d{2}([ -])|08\d{2}([ -]?)|\+628\d{2})\d{4}(\3\4)\d{2,6})$/i;
  const regex_email =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

  const handleChange = (event, name) => {
    setValues({ ...values, [name]: event.target.value });
  };

  const handleSubmit = async (e) => {
    if (!values.email || !values.phone_number) {
      setIsError(true);
    } else {
      try {
        const result = await updateCandidateEmailPhoneNumber(client, values);
        if (result.status !== "000") {
          if (result.errMsg === "NOK: Phone Number Already Exist!") {
            toastWarning("Phone number already exist!");
          } else if (result.errMsg === "NOK: Email Already Exist!") {
            toastWarning("Email already exist!");
          } else {
            toastError("Error, please try again later");
          }
        } else {
          toastSuccess("Success resend OTP");
          setChangeVerification(false);
          setData({ ...data, email: values.email, phone_number: values.phone_number });
        }
      } catch (error) {
        return { errMsg: { error } };
      }
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="360px"
      padding="16px"
      gap="27px"
      position="relative"
      fontSize={14}>
      <Header>
        <ArrowBackIcon
          className="text-primary-main-hover"
          style={{ cursor: "pointer" }}
          onClick={() => setChangeVerification(false)}
        />
        Change Verification
      </Header>
      <Body>
        <FormGroup
          className="w-100"
          label={"Email Address"}
          isRequired
          errorMessage={
            isError && !values.email
              ? "Email cannot be empty!"
              : !values.email?.match(regex_email)
              ? "Incorrect email format"
              : ""
          }
          isError={Boolean(
            (isError && !values.email) || (!values.email?.match(regex_email) && values.email)
          )}
          showChildErrorSign>
          <Input
            type="text"
            placeholder={"Input Email Address"}
            value={values.email}
            onChange={(e) => handleChange(e, "email")}
          />
        </FormGroup>
        <FormGroup
          className="w-100"
          label={"No. Handphone"}
          isRequired
          errorMessage={
            isError && !values.phone_number
              ? "Phone Number cannot be empty!"
              : !values.phone_number?.match(regex_phone)
              ? "Phone Number not valid, Format must start with 08xx and be at least 8 characters long"
              : ""
          }
          isError={Boolean(
            (isError && !values.phone_number) ||
              (!values.phone_number?.match(regex_phone) && values.phone_number)
          )}
          showChildErrorSign>
          <Input
            type="number"
            placeholder={"Input No. Handphone"}
            value={values.phone_number}
            onChange={(e) => handleChange(e, "phone_number")}
          />
        </FormGroup>
      </Body>
      <Button
        variant="contained"
        color="primary"
        onClick={() => handleSubmit()}
        style={{ width: "100%" }}>
        Send
      </Button>
    </Box>
  );
};

export default ChangeVerification;
